import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["onAccept", "onDecline"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useState } from 'react';
export function useDialogParams() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    dialogProps = _useState6[0],
    setDialogProps = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    loading = _useState8[0],
    setLoading = _useState8[1];
  var close = useCallback(function () {
    setLoading(false);
    setError(undefined);
    setOpen(false);
    setDialogProps(null);
  }, []);
  var confirm = useCallback(function (params) {
    var _params$onAccept = params.onAccept,
      acceptHandler = _params$onAccept === void 0 ? Function.prototype : _params$onAccept,
      _params$onDecline = params.onDecline,
      declineHandler = _params$onDecline === void 0 ? Function.prototype : _params$onDecline,
      rest = _objectWithoutProperties(params, _excluded);
    var onAccept = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setLoading(true);
                _context.prev = 1;
                _context.next = 4;
                return acceptHandler();
              case 4:
                close();
                _context.next = 10;
                break;
              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);
                setError(_context.t0.message);
              case 10:
                _context.prev = 10;
                setLoading(false);
                return _context.finish(10);
              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 7, 10, 13]]);
      }));
      return function onAccept() {
        return _ref.apply(this, arguments);
      };
    }();
    var onDecline = function onDecline() {
      declineHandler();
      close();
    };
    setDialogProps(_objectSpread(_objectSpread({}, rest), {}, {
      onAccept: onAccept,
      onDecline: onDecline
    }));
    setOpen(true);
  }, [close]);
  return {
    dialogParams: _objectSpread(_objectSpread({}, dialogProps), {}, {
      error: error,
      loading: loading,
      open: open
    }),
    confirm: confirm
  };
}